module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Block3-7544d57b73b2af18dc0ee7b02c41bb30.png";